/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/daswerk/"

const DASWERK: CommunityData = {
  code: "daswerk",
  inviteCode: "daswerk",
  name: "DAS WERK",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/dwe-030`,
  waitlist: true,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[128px] h-[128px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[128px] h-[128px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ebebeb",
      asideBg: "#ebebeb",
      asideStyles: "!gap-0 !py-0 border-r border-[#bdbdbd]",
      contentBg: "#ebebeb",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      mainFont: "font-['InterRegular']",
      primaryButton:
        "bg-[#000000] border border-[#000000] px-[18px] py-[18px] !text-[#ffffff] font-['GeistMonoMedium'] !text-[17px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#222222",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#d5d5d5]",
      item: "font-['GeistPixelGrid'] text-[16px] text-[#222222] text-center leading-[100%] gap-x-[10px] text-opacity-50 border-b border-[#d5d5d5] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#ebebeb] !pb-8",
      titles:
        "text-[#000000] font-['GeistPixelGrid'] text-[26px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#222222] font-['GeistMonoLight'] text-[12px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#d5d5d5]",
        sectionTitle:
          "text-[#000000] font-['GeistPixelGrid'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ebebeb]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative overflow-hidden",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#222222] font-['GeistMonoLight'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#d5d5d5]",
        sectionTitle:
          "text-[#000000] font-['GeistPixelGrid'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ebebeb]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-0 sm:px-4 py-4 sm:!py-0 bg-transparent",
          title:
            "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#222222] font-['GeistMonoLight'] text-[11px] text-left leading-[120%] mt-2",
          location:
            "text-[#222222] font-['GeistMonoLight'] text-[11px] text-left leading-[120%] mt-1",
          date: "text-[#222222] font-['GeistMonoLight'] text-[11px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#000000] font-['GeistPixelGrid'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#222222] font-['GeistMonoLight'] text-[14px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['GeistPixelGrid'] text-[26px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ebebeb] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#d5d5d5]",
        media: "sm:!w-[320px] w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#000000] font-['GeistPixelGrid'] text-[26px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#222222] font-['GeistMonoLight'] text-[12px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#000000] border border-[#000000] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['GeistMonoMedium'] !text-[17px] uppercase text-left leading-[100%]",
        questions: "text-[12px] text-left leading-[120%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#d5d5d5]",
        header:
          "text-[#000000] font-['GeistPixelGrid'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#222222] font-['GeistMonoLight'] text-[12px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#d5d5d5]",
        header:
          "text-[#000000] font-['GeistPixelGrid'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#222222] font-['GeistMonoLight'] text-[12px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['GeistPixelGrid'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#222222] font-['GeistMonoLight'] text-[12px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['GeistPixelGrid'] text-[26px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ebebeb] !pb-8",
        innerContainer: "flex flex-col px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ebebeb] border border-[#000000] px-[12px] py-[12px] text-[#000000] font-['GeistMonoMedium'] text-[15px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ebebeb] border-b border-[#d5d5d5] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#222222] font-['GeistMonoLight'] text-[12px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#222222] font-['GeistPixelGrid'] text-[16px] uppercase text-left leading-[110%]",
          quantity:
            "text-[#000000] font-['GeistMonoMedium'] text-[15px] uppercase text-left leading-[100%]",
          status:
            "text-[#222222] font-['GeistPixelGrid'] text-[16px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#ebebeb] border border-[#000000] px-[12px] py-[12px] gap-x-[16px] !w-fit",
          button:
            "bg-[#ebebeb] border border-[#000000] px-[12px] py-[12px] text-[#000000] font-['GeistMonoMedium'] text-[15px] uppercase text-left leading-[100%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
    comingSoon: {
      bgColor: "#ebebeb",
      hero: {
        desktop: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
        mobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
        style: "bg-[#bdbdbd]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-logo.png`,
        mobile: `${S3_PREFIX}web-logo.png`,
        style: "w-[96px] h-[96px] sm:w-[128px] sm:h-[128px] object-contain",
      },
      werzLogoColor: "#191818",
      title: "font-['GeistPixelGrid'] text-[26px] uppercase leading-[110%] text-[#000000]",
      text: "font-['GeistMonoLight'] text-[14px] leading-[120%] text-[#222222]",
      button:
        "font-['GeistMonoMedium'] text-[15px] uppercase leading-[100%] p-4 bg-[#000000] text-[#ffffff] cursor-pointer w-fit",
      input: {
        base: "font-['GeistMonoLight'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-white text-[#222222]",
        border: "#bdbdbd",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['GeistMonoLight'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['GeistMonoLight'] text-[12px] leading-[120%] text-[#222222]",
      skipButton:
        "font-['GeistMonoLight'] text-[14px] leading-[120%] text-[#222222] cursor-pointer",
      modal: {
        container: "bg-[#ebebeb] px-[40px] py-[48px]",
        title:
          "font-['GeistPixelGrid'] text-[24px] uppercase leading-[110%] text-[#000000] text-center",
        text: "font-['GeistMonoLight'] text-[14px] leading-[120%] text-[#222222] text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] text-black bg-white font-['GeistMonoMedium'] text-[16px] leading-[120%] text-center",
        otpBorder: "#bdbdbd",
        otpBorderFocus: "#000000",
      },
    },
    linktree: {
      bgDesktop: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      bgColor: "#ebebeb",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#ebebeb]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full object-cover",
        name: "text-[#000000] font-['GeistPixelGrid'] text-[24px] uppercase text-center mt-4 mb-1",
        location: "text-[#222222] font-['GeistMonoLight'] text-[16px] text-center mb-2",
        description:
          "text-[#222222] font-['GeistMonoLight'] text-[16px] text-center leading-[120%] mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#ebebeb] border border-[#000000] px-[16px] py-[16px] text-[#000000] font-['GeistMonoMedium'] text-[15px] uppercase text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ebebeb] text-[#222222] font-['GeistMonoLight'] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#ebebeb]",
          title: "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-center mb-1",
          text: "text-[#222222] font-['GeistMonoLight'] text-[16px] leading-[120%] text-center",
          button:
            "bg-[#ebebeb] border border-[#000000] px-[16px] py-[16px] text-[#000000] font-['GeistMonoMedium'] text-[15px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ebebeb]",
          duration: "text-[#222222] font-['GeistMonoLight'] text-[14px] leading-[120%] text-left",
          name: "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "overflow-hidden m-2",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#ebebeb]",
          name: "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#ebebeb] border border-[#000000] text-[#000000] font-['GeistPixelGrid'] text-[14px] uppercase text-center",
          duration: "text-[#222222] font-['GeistMonoLight'] text-[14px] leading-[120%] text-left",
          location: "text-[#222222] font-['GeistMonoLight'] text-[14px] leading-[120%] text-left",
          button:
            "bg-[#ebebeb] border border-[#000000] px-[16px] py-[16px] text-[#000000] font-['GeistMonoMedium'] text-[15px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#d5d5d5]",
            name: "text-[#000000] font-['GeistMonoMedium'] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#000000] font-['GeistMonoMedium'] text-[14px] text-left",
            link: "text-[#222222] font-['GeistMonoLight'] text-[12px] leading-[120%] text-left",
            status:
              "text-[#222222] font-['GeistPixelGrid'] text-[14px] uppercase leading-[100%] text-left",
            button:
              "bg-[#ebebeb] border border-[#000000] px-[16px] py-[16px] text-[#000000] font-['GeistMonoMedium'] text-[15px] uppercase text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#222222] font-['GeistMonoLight'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        container: "flex flex-col gap-4",
        header:
          "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-center mb-[10px]",
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ebebeb] text-[#222222] font-['GeistMonoLight'] text-[16px] leading-[120%] text-center",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ebebeb]",
          coverUrl: "overflow-hidden m-2",
          duration: "text-[#222222] font-['GeistMonoLight'] text-[14px] leading-[120%] text-left",
          liveType: "text-[#222222] font-['GeistMonoLight'] text-[12px] leading-[120%] text-left",
          liveTypeCircle: "bg-[#222222]",
          playIconColor: "#000000",
          playIconBackgroundColor: "#ebebeb",
          playIconBorderColor: "#000000",
          start: "text-[#222222] font-['GeistMonoLight'] text-[14px] leading-[120%] text-left",
          title:
            "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#222222] font-['GeistMonoLight'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ebebeb] text-[#222222] font-['GeistMonoLight'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ebebeb]",
          name: "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[#222222] font-['GeistMonoLight'] text-[14px] leading-[120%] text-left",
          media: "overflow-hidden m-2",
        },
        seeAllNews:
          "text-[#222222] font-['GeistMonoLight'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ebebeb] text-[#222222] font-['GeistMonoLight'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#ebebeb]",
          name: "text-[#000000] font-['GeistPixelGrid'] text-[16px] uppercase text-left",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#191818",
        text: "text-[#222222] font-['GeistMonoLight'] text-[12px] text-left",
      },
    },
  },
}

export default DASWERK
